export default __webpack_public_path__ + "static/media/smart-workout.d19c517f.mp4";